var eventList = require('./eventList')

var filteredList = []
var itemPerPage = 5
var pages = 1
var actualPage = 1

$(document).ready(function() {
  var select = $('#select-years')

  // Listen to select value change for filtering
  select.change(function (event) {
    actualPage = 1
    var value = event.target.value
    console.log(value)
    processFilter(value)
  })

  // Read query string for filtering
  var query = window.location.search
  var params = new URLSearchParams(query)
  var filter = params.get('filter')
  if(filter != null) {
    $('#select-years option').each(function (index, elem) {
      var option = $(this)
      var optionValue = option.attr('value')
      if(option.attr('value') === filter) {
        option.attr('selected', true)
        select.trigger('change')
      }
    })
  } else {
    filteredList = eventList
    renderPaginator()
  }
});

function processFilter(value) {
  if (value !== 'all') {
    filteredList = eventList.filter(item => item.year === value)
  } else {
    filteredList = eventList
  }
  renderPaginator()
}

function fillEventList() {
  $('ul').remove('.event-item')
  var listContainer = $('#events-container')
  var startIndex = actualPage * itemPerPage - itemPerPage 
  var endIndex = startIndex + itemPerPage

  // In case endIndex is greater than max index of list
  if (endIndex > filteredList.length) {
    endIndex = filteredList.length
  }

  var pageSlice = filteredList.slice(startIndex, endIndex)
  $.map(pageSlice, function(val, i) {
    var item = '<ul class="event-item ' + val.year + '">'
    item += '<li class="col-sm-5 no-padding eve-img"> <img class="img-responsive" src="' + val.img + '" alt="">'
    if (val.month !== '') {
      item += '<div class="date">' + val.day
      item += '<p>' + val.month + '</p></div>'
    }
    item += '</li><li class="col-sm-7 no-padding"><div class="event-detail"><h4>'+ val.name + '</h4>'
    item += '<span><i class="ion-ios-location-outline"></i>'+ val.type + '</span> <span><i class="ion-ios-clock-outline"></i>' + val.time + '</span>'
    item += '<p>'
    var max = val.presenters.length >= 4 ? val.presenters.length : 4
    for(var index = 0; index <= max; index++ ) {
      if(val.presenters[index]) {
        item += val.presenters[index] + '<br>'
      } else {
        item += '<br>'
      }
    }
    item += '</p>'
    if (val.links.length > 1) {
      item += '<div class="dropdown">'
      item += '<button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu' + i + '" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">'
      item += 'More Info <span class="caret"></span></button>'
      item += '<ul class="dropdown-menu" aria-labelledby="dropdownMenu' + i + '">'
      for(var index = 0; index < val.links.length; index++ ) {
        item += '<li><a href="' + val.links[index] + '" target="_blank">Parte'+ (index + 1) + '</a></li>'
      }
      item += '</ul></div>'
    } else {
      item += '<a href="' + val.links[0] + '" target="_blank" class="btn">More Info</a>'
    }
    item += '</div></li></ul>'
    listContainer.append(item)
  })
  setPaginatorColor()
}

function getPagesCount () {
  return Math.ceil(filteredList.length / itemPerPage)
}

function createPaginator() {
  $('li').remove('.paginator-item')
  var paginationContainer = $('.pagination')
  var htmlItem = ''
  pages = getPagesCount()
  var paginationSize = 7
  var maxDistanceToEdge = Math.floor(paginationSize / 2)
  if (filteredList.length > itemPerPage) {
    htmlItem += '<li class="paginator-item" onClick="prev()"><a href="#" onclick="return false;">Prev</a></li>'
    if (actualPage > maxDistanceToEdge + 1) htmlItem += '<li class="paginator-item" data-page="1" onClick="toPage(this)"><a href="#" onclick="return false;">...</a></li>'
    var initialIndex = actualPage > maxDistanceToEdge + 1 ? (actualPage - maxDistanceToEdge -1) : 0
    for (var index = initialIndex ; index < actualPage + maxDistanceToEdge && index < pages; index ++) {
      htmlItem += '<li class="paginator-item" data-page="'+ (index + 1) +'" onClick="toPage(this)">'
      htmlItem += '<a href="#" onclick="return false;">'+ (index + 1) + '</a></li>'
    }
    if (pages - actualPage > maxDistanceToEdge) htmlItem += '<li class="paginator-item" data-page="' + pages + '" onClick="toPage(this)"><a href="#" onclick="return false;">...</a></li>'
    htmlItem += '<li class="paginator-item" onClick="next()"><a href="#" onclick="return false;">Next</a></li>'
    paginationContainer.append(htmlItem)
  }
}

function renderPaginator() {
  createPaginator()
  fillEventList()
}

function next() {
  if (actualPage + 1 <= pages) {
    actualPage ++
    renderPaginator()
  }
}

function prev() {
  if (actualPage - 1 >= 1) {
    actualPage --
    renderPaginator()
  }
}

function toPage(event) {
  actualPage = parseInt(event.getAttribute('data-page'))
  renderPaginator()
}

function setPaginatorColor() {
  $('.paginator-item').each(function() {
    var data = parseInt($(this).attr('data-page'))
    if (data === actualPage) {
      $(this).addClass('page-active')
    } else {
      $(this).removeClass('page-active')
    }
  })
  document.getElementById('year-filter').scrollIntoView({
    behavior: 'smooth'
  })
}

// Bind to public object
window.next = next
window.prev = prev
window.toPage = toPage